import { h } from 'preact'
import styles from './footer.module.css'
import { Published } from './published.tsx'
import { Author } from './author.tsx'

export const Footer = ({ meta, byline = [], showPublicationDate = true }) => {
  const mappedByline =
    byline &&
    byline.length > 0 &&
    byline.map(({ email = '', displayname = '', role = '' }) => (
      <Author email={email} displayname={displayname} role={role} />
    ))
  return (
    <footer className={styles.footer}>
      {showPublicationDate && <Published meta={meta} />}
      <div>{mappedByline}</div>
    </footer>
  )
}
